import gql from "graphql-tag";

export const MY_HR_REFRESH_TOKEN = gql`
  mutation refreshToken($accessToken: String!) {
    refreshToken(accessToken: $accessToken) {
      accessToken
      accessTokenPeriod
      sessionPeriod
    }
  }
`;
